import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=916d95e4&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=916d95e4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916d95e4",
  null
  
)

export default component.exports